import { Button, InputNumber, Modal, Typography } from 'antd';
import React from 'react'
import AttestationTPVToPrint from '../../components/docs/AttestationTPVToPrint';
import AttestationTPV from '../../components/docs/AttestationTPV';
import AttestationMotoToPrint from '../../components/docs/AttestationMotoToPrint';
import AttestationMoto from '../../components/docs/AttestationMoto';
import { PrinterOutlined } from '@ant-design/icons';
import { toast } from 'react-toastify';

const { Title } = Typography;

const ImprimerAttestation = ({
    contrat,
    modalAttOpen,
    setModalAttOpen,
    onTabsChange,
    printingAttestation,
    printAttestation,
    printedAttestation,
    setPrintingAttestation,
    attestationDamaged,
    numeroAttestation,
    setNumeroAttestation,
    loadingPrinting,
    setLoadingPrinting,
    regle,
    rightsService,
    attestationPrinting,
    printingDamagedAttestation,
    attestationNonPrintedPrinting,
    attestationDamagedPrinting,
    layout,
    setLayout,
    setAttestationDamaged
}) => {
    const secondaryColor = "#242166";
    return (
        <Modal
            title={
                <Title level={4} style={{ margin: 0, color: secondaryColor }}>
                    <PrinterOutlined style={{ marginRight: 8 }} />
                    Attestation d'Assurance
                </Title>
            }
            centered
            open={modalAttOpen}
            onOk={() => {
                onTabsChange("1");
                setModalAttOpen(false);
            }}
            onCancel={() => {
                onTabsChange("1");
                setModalAttOpen(false);
            }}
            width={1200}
            zIndex={2000}
        >
            {contrat?.engins?.[0]?.categorie
                ?.nom?.toUpperCase()?.startsWith("TRANSPORT") ? (
                contrat?.engins?.map((eng, id) => (
                    <div key={id}>
                        <div className="container" justify="center" >
                            <div
                                className="grid-item"
                                lg={12}
                            >
                                <div ref={printedAttestation}>
                                    {printingAttestation ?
                                        <AttestationTPVToPrint
                                            contrat={contrat}
                                            engin={eng}
                                        /> :
                                        <AttestationTPV
                                            ref={printAttestation}
                                            contrat={contrat}
                                            engin={eng}
                                            printing={
                                                printingAttestation
                                            }
                                        />
                                    }

                                    <br />
                                    <br />
                                    <br />
                                    <br />
                                    <br />
                                    <br />
                                    <br />
                                    <br />
                                    <br />
                                    <br />
                                    <br />
                                    <br />
                                    <br />
                                    <br />
                                    <br />
                                </div>
                            </div>
                        </div>
                        {!eng.numeroAttestation || attestationDamaged ? <>
                            <InputNumber
                                style={{
                                    width: 200,
                                }}
                                placeholder="Numéro d'attestation"
                                value={numeroAttestation}
                                onChange={(v) => {
                                    setNumeroAttestation(v);
                                    console.log(v);
                                }}
                                formatter={(value) =>
                                    `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, " ")
                                }
                                parser={(value) =>
                                    value.replace(/\s/g, "")
                                }
                            />
                            <br />
                            <br />
                            <Button
                                onClick={() => {
                                    setLayout("landscape");
                                    console.log(
                                        "nA: ",
                                        numeroAttestation
                                    );
                                    if (
                                        numeroAttestation < 1000
                                    ) {
                                        toast.error(
                                            "Veuillez renseigner un numéro d'attestation valide"
                                        );
                                    } else {
                                        setPrintingAttestation(true);
                                        setLoadingPrinting(true);
                                        attestationDamaged ? printingDamagedAttestation(eng) : attestationPrinting(eng);
                                    }

                                }}
                                type="primary"
                                icon={<PrinterOutlined />}
                                style={{
                                    background: "green",
                                }}
                                disabled={!regle || !rightsService("HCO007") || contrat?.suspendu || contrat?.resilie || contrat?.avenant?.code?.startsWith("RS") || contrat?.avenant?.code?.startsWith("SP")}
                                loading={loadingPrinting}
                            >
                                Imprimer
                            </Button>
                        </> :
                            <>
                                <Button
                                    onClick={() => {
                                        setPrintingAttestation(true);
                                        attestationNonPrintedPrinting(eng);
                                    }}
                                    type="primary"
                                    style={{
                                        background: "gray",
                                        color: "white"
                                    }}
                                    disabled={!regle || !rightsService("HCO007")}
                                >
                                    Impression non effectuée
                                </Button>

                                <Button
                                    onClick={() => {

                                        attestationDamagedPrinting(eng);

                                    }}
                                    type="primary"
                                    style={{
                                        background: "orange",
                                        color: "white"
                                    }}
                                    disabled={!regle || !rightsService("HCO007")}
                                >
                                    Attestation bourrée / endommagée
                                </Button>
                            </>}
                    </div>))
            ) : null}

            {contrat?.engins?.[0]?.categorie
                ?.codeCategorie === "M" ? (
                contrat?.engins?.map((eng, id) => (
                    <div key={id}>
                        <div className="container" justify="center" >
                            <div
                                className="grid-item"
                                lg={12}
                            >
                                <div ref={printedAttestation}>
                                    {printingAttestation ?
                                        <AttestationMotoToPrint
                                            contrat={contrat}
                                            engin={eng}
                                        /> :
                                        <AttestationMoto
                                            ref={printAttestation}
                                            contrat={contrat}
                                            engin={eng}
                                            printing={
                                                printingAttestation
                                            }
                                        />
                                    }

                                    <br />
                                    <br />
                                    <br />
                                    <br />
                                    <br />
                                    <br />
                                    <br />
                                    <br />
                                    <br />
                                    <br />
                                    <br />
                                    <br />
                                    <br />
                                    <br />
                                    <br />
                                </div>
                            </div>
                        </div>
                        {!eng.numeroAttestation || attestationDamaged ? <>
                            <InputNumber
                                style={{
                                    width: 200,
                                }}
                                placeholder="Numéro d'attestation"
                                value={numeroAttestation}
                                onChange={(v) => {
                                    setNumeroAttestation(v);
                                    console.log(v);
                                }}
                                formatter={(value) =>
                                    `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, " ")
                                }
                                parser={(value) =>
                                    value.replace(/\s/g, "")
                                }
                            />
                            <br />
                            <br />
                            <Button
                                onClick={() => {
                                    setLayout("landscape");
                                    console.log(
                                        "nA: ",
                                        numeroAttestation
                                    );
                                    if (
                                        numeroAttestation < 1000
                                    ) {
                                        toast.error(
                                            "Veuillez renseigner un numéro d'attestation valide"
                                        );
                                    } else {
                                        setPrintingAttestation(true);
                                        setLoadingPrinting(true);
                                        attestationDamaged ? printingDamagedAttestation(eng) : attestationPrinting(eng);
                                    }

                                }}
                                icon={<PrinterOutlined />}
                                type="primary"
                                style={{
                                    background: "green",
                                }}
                                disabled={!regle || !rightsService("HCO007") || contrat?.suspendu || contrat?.resilie || contrat?.avenant?.code?.startsWith("RS") || contrat?.avenant?.code?.startsWith("SP")}
                                loading={loadingPrinting}
                            >
                                Imprimer
                            </Button>
                        </> :
                            <>
                                <Button
                                    onClick={() => {
                                        attestationNonPrintedPrinting(eng);
                                    }}
                                    type="primary"
                                    style={{
                                        background: "gray",
                                        color: "white"
                                    }}
                                    disabled={!regle || !rightsService("HCO007")}
                                >
                                    Impression non effectuée
                                </Button>

                                <Button
                                    onClick={() => {

                                        attestationDamagedPrinting(eng);

                                    }}
                                    type="primary"
                                    style={{
                                        background: "orange",
                                        color: "white"
                                    }}
                                    disabled={!regle || !rightsService("HCO007")}
                                >
                                    Attestation bourrée / endommagée
                                </Button>
                            </>}
                    </div>))
            ) : null}
        </Modal>
    )
}

export default ImprimerAttestation
